import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'
import Roadmap from '../../Roadmap';
import Team from "../Team"
import News from "../News"
import JoinUs from "../JoinUs"
import ContentOrnaments from "../../ContentOrnament";
import ReactPlayer from "react-player";
import router from "next/router";
import SpecialBtn from "../Mint/SpecialBtn"

// Component
function Home(props: any) {
    const theme = useTheme();
    const showRoadMapHorLine = useMediaQuery(theme.breakpoints.up(1200));
    const { t } = useTranslation();

    //
    function gotoMintPage() {
        router.push("/mint")
    }

    //
    return (
        <Box className={props.className}>
            <Box className="home-front-dragon-container home-gate-bg-img">
                <Box className="home-front-logo-and-btns ">

                    <img src="Eternal Dragons_Gold_Dropshadow.png" className="home-front-dragon-img" alt="eternal dragons main front image" />

                    <Box sx={{ textAlign: "center", fontFamily: "Cinzel", fontSize: "32px", fontWeight: 700, color: "#ffeba2", margin: "0px 5px 0px 5px", textShadow: "0 0 10px #4a453d" }}>
                        NFT SALE COMPLETE
                    </Box>

                    <Box sx={{ textAlign: "center", fontFamily: "Cinzel", fontSize: "32px", fontWeight: 700, color: "#ffeba2", margin: "0px 5px 0px 5px", textShadow: "0 0 10px #4a453d" }}>
                        ALL GENESIS DRAGONS MINTED
                    </Box>
                </Box>
            </Box>

            {/* Trailer movie */}
            <Box sx={{
                display: "flex", justifyContent: "center", alignItems: 'center',
                flexDirection: "column", maxWidth: "960px", margin: "40px auto 20px auto", padding: "10px"
            }}>
                <Box sx={{ fontFamily: "Cinzel", fontSize: "25px", fontWeight: 700, color: "#333333", margin: "10px 0px 30px 0px", width: "100%", textAlign: "center", lineHeight: 1.2 }} >
                    FIND OUR COLLECTION ON
                </Box>

                <img src="Magic_Eden_button.png"
                    style={{ maxWidth: "300px", width: "100%", margin: "0 0 70px 0", cursor: "pointer" }}
                    alt="eternal dragons magic Eden button"
                    onClick={() => window.open('https://magiceden.io/marketplace/eternal_dragons_genesis', '_blank')} />

                <ReactPlayer
                    className='home-trailer-movie'
                    url="https://www.youtube.com/watch?v=RtoO5-uOXmo"
                    width='100%'
                    height='100%'
                    loop={false}
                    muted={false}
                    playing={false}
                    playsinline={true}
                    autoPlay={true}
                    preload={"auto"}
                    controls={true}
                    style={{ display: "inline-block" }} />
            </Box>

            {/* White box with text */}
            <Box className="home-whitebox-container" style={{ paddingBottom: 50 }}>
                <Typography className="home-whitebox-header">
                    {t("home.newEraHeader")}
                </Typography>

                <Box sx={{ textAlign: "center" }}>
                    <Box className="home-whitebox-content" style={{ position: "relative" }}>
                        <ContentOrnaments />
                        {t("home.newEraText")}
                    </Box>
                </Box>

                <Box sx={{ textAlign: "center" }}>
                    <Button variant="contained" onClick={() => window.open("https://www.eternaldragons.com/whitepaper", "_blank")} className="home-whitebox-btn">
                        {t("menu.whitepaper")}
                    </Button>
                </Box>
            </Box>

            {/* Hatching image */}
            <Box className="home-hatching-bg-img"></Box>

            {/* White box with text */}
            <Box className="home-whitebox-container">
                <Typography className="home-whitebox-header">
                    {t("home.createHistoryHeader")}
                </Typography>

                <Box sx={{ textAlign: "center" }}>
                    <Box className="home-whitebox-content" style={{ position: "relative" }}>
                        <ContentOrnaments />
                        {t("home.createHistoryText")}
                    </Box>
                </Box>
            </Box>

            {/* Dragon movie*/}
            <Box className="home-front-dragon-video-cont">
                <ReactPlayer
                    className='home-front-dragon-video'
                    url="FV_Eternal_Dragons_loop_v03.mp4"
                    width='100%'
                    height='100%'
                    loop={true}
                    muted={true}
                    playing={true}
                    playsinline={true}
                    autoPlay={true}
                    preload={"auto"}
                    controls={false}
                    style={{ display: "inline-block" }} />
            </Box>

            {/* White box with text */}
            <Box className="home-whitebox-container">
                <Typography className="home-whitebox-header">
                    {t("home.breedDragonsHeader")}
                </Typography>

                <Box sx={{ textAlign: "center" }}>
                    <Box className="home-whitebox-content" style={{ position: "relative" }}>
                        <ContentOrnaments />
                        {t("home.breedDragonsText")}
                    </Box>
                </Box>
            </Box>

            {/* Roadmap */}
            <Roadmap />

            {/* News */}
            <News />

            {/* Investors */}
            <Box className="home-whitebox-container" style={{ padding: 0, marginTop: "20px" }}>
                <Box>
                    <img src="Ornament_SectionBreakTwistedDragons.png" alt="team members top ornament" style={{ maxWidth: "800px", width: "100%", padding: "20px" }} />
                </Box>

                <Typography className="home-whitebox-header">
                    {t("home.investorsHeader")}
                </Typography>

                <Box className="home-investor-item-container">
                    <Box className="home-investor-item">
                        <img alt="play venture logo" src="Play_Venture_Logoblack.png" style={{ maxWidth: "300px", paddingBottom: "20px", width: "100%" }} />
                    </Box>

                    <Box className="home-investor-item">
                        <img alt="makers fund logo" src="makers fund logo.png" style={{ maxWidth: "300px", paddingBottom: "20px", width: "100%" }} />
                    </Box>

                    <Box className="home-investor-item">
                        <img alt="fabric ventures logo" src="fabric ventures.png" style={{ maxWidth: "300px", paddingBottom: "20px", width: "100%" }} />
                    </Box>
                </Box>
            </Box>

            {/* Team */}
            <Box id="team" style={{ position: "relative", top: -60 }}></Box>
            <Team />

            {/* Team */}
            <Box id="joinus" style={{ position: "relative", top: -40 }}></Box>
            <JoinUs />

        </Box>
    );
}

// Default style!
const HomeStyled = styled(Home)({

    ".home-discord-btn": {
        backgroundColor: "#5865f2",
        margin: "10px 10px 10px 10px",
        width: "180px",
        backgroundImage: "url(Discord_Logo_Wordmark_White.png)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPositionX: "50%",
        "&:hover": {
            backgroundColor: "#7580ef!important"
        }
    },
    ".home-front-dragon-container": {
        position: "relative",
        background: "grey",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
    },
    ".home-front-dragon-video": {
        width: "100%",
    },
    ".home-front-dragon-img": {
        width: "100%",
        maxWidth: "700px",
        marginBottom: "1%",
        padding: "150px 10px 0 10px",
        //position: "absolute",
        //bottom: "-110px"
    },
    ".home-front-dragons-group-img": {
        width: "100%",
        maxWidth: "880px",
        padding: "10px"
    },
    ".home-front-play-and-prosper-img": {
        width: "100%",
        maxWidth: "320px",
        margin: "20px 0px 20px 0px",
        padding: "0 10px 0 10px",
        marginTop: "11%"
    },
    ".home-front-join-comm-img": {
        width: "100%",
        maxWidth: "360px",
        marginBottom: "0px",
        padding: "0 10px 0 10px"
    },
    ".home-front-logo-and-btns": {
        //position: "absolute",
        marginTop: "0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "600px"
    },
    ".home-front-text": {
        //position: "absolute",      
        maxWidth: "650px",
        color: "white",
        fontWeight: 700,
        padding: "10px 10px 20px 10px",
        textAlign: "center",
        fontSize: "18px",
        textShadow: "3px 3px 3px #484848"
    },
    ".home-front-btns": {
        transition: "opacity 0.4s",
        "&:hover": {
            opacity: 0.7,
            cursor: "pointer"
        }
    },
    ".home-mc-container": {

        "& button": {
            background: "#a2e2ef",
            width: "180px",
            color: "black",
            fontWeight: 700,
            "&:hover": {
                background: "#fffc74"
            }
        }
    },
    ".home-front-discord-btn": {
        margin: "10px",
        borderRadius: 0,
        background: "#3c80d1",
        fontWeight: 700,
        fontSize: "16px",
        color: "white",
        width: "180px",
        padding: "8px",
        "&:hover": {
            background: "#378bef"
        }
    },
    ".home-front-discord-icon": {
        height: "23px",
        paddingRight: "10px"
    },
    ".home-front-social-icon": {
        padding: "4px",
        margin: "7px",
        fontSize: "35px",
        borderRadius: "20px",
        display: "inline-block"
    },
    ".home-whitebox-container": {
        background: "white",
        height: "auto",
        padding: "50px 20px 80px 20px",
        textAlign: "center"
    },
    ".home-whitebox-header": {
        color: "#181f27",
        fontWeight: "700",
        fontSize: "40px",
        paddingBottom: "20px",
        lineHeight: 1.2
    },
    ".home-whitebox-content": {
        color: "#181f27",
        fontWeight: "400",
        padding: "20px",
        fontSize: "19px",
        maxWidth: "600px",
        //border: "2px solid #181f27",
        display: "inline-block"
    },
    ".home-whitebox-btn": {
        display: "inline-block",
        background: "#181f27",
        color: "white",
        borderRadius: "0px",
        fontWeight: 700,
        width: "150px",
        clear: "both",
        position: "relative",
        top: "-12px"
    },
    ".home-gate-bg-img": {
        backgroundImage: "url(Header_completeMint_BG_fhd.jpg)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 36%",
        height: "1000px"
    },
    ".home-hatching-bg-img": {
        backgroundImage: "url(eternaldragons_website_illustration_03_sm.jpg)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 65%",
        height: "550px"
    },
    ".home-investor-item-container": {
        margin: "auto",
        //padding: "20px",
        maxWidth: "1500px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    ".home-investor-item": {
        lineHeight: "1",
        fontWeight: 700,
        color: "#181f27",
        background: "white",
        display: "inline-block",
        padding: "40px"
    },
    ['@media (max-width:901px)']: {
        ".home-front-dragon-video-cont": {
            overflow: "hidden",
            height: "600px",
            "video": {
                transform: "scale(1.9) translate(-17px, 0px)",
                display: "block"
            }
        }
    },
    ['@media (max-width:520px)']: {
        ".home-front-dragon-video-cont": {
            overflow: "hidden",
            height: "600px",
            "video": {
                transform: "scale(3.4) translate(-17px, 0px)",
                display: "block"
            }
        }
    },
    ['@media (max-width:500px)']: {
        ".home-gate-bg-img": {
            backgroundImage: "url(Header_completeMint_BG_fhd.jpg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% 36%",
            height: "750px"
        },
        ".home-front-logo-and-btns": {
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        ".home-front-join-comm-img": {
            width: "100%",
            maxWidth: "290px",
            marginBottom: "0px",
            padding: "0 10px 0 10px"
        }
    },
    ".home-trailer-movie": {
        position: "relative",
        height: 0,
        width: "100%",
        "div": {
            paddingBottom: "56.25%!important", /* 16:9 */
            iframe: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
            }
        }
    }
});

// Export
export default HomeStyled;
